import React, { Fragment, memo } from 'react'
import prop from 'ramda/src/prop'
import head from 'ramda/src/head'
import toLower from 'ramda/src/toLower'
import { camelCaseSpace } from 'root/src/shared/util/stringCase'
import classNames from 'classnames'
import { orNull } from 'root/src/shared/util/ramdaPlus'
import CountdownTimer from 'root/src/client/web/base/CountdownTimer'
import format2Decimals from 'root/src/shared/util/format2Decimals'
import goToViewCreatorDataHandler from 'root/src/client/logic/creatorData/handlers/goToViewCreatorDataHandler'
import Sponsoring from 'root/src/client/web/record/ViewProject/Sponsoring'
import assigneeRouteSelector from 'root/src/client/logic/project/util/assigneeRouteSelector'
import getBountyName from 'root/src/shared/util/getBountyName'
import { addHttpsProtocol } from 'root/src/shared/util/protocolUtil'
import { useClipboard } from 'root/src/client/web/hooks/useClipboard'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/pro-light-svg-icons'

export default memo(({ classes, projectDeliveries, DareDetailsTitleAndDescription,
	games, timeLeft, pledgers, pledgeAmount, goalAmount, brandProduct, creatorData,
	isTwitchPanelDare, isMobileRes, sponsor, landingShortUrl, isOneOfAssignees, campaignId,
}) => {
	const className = projectDeliveries
		? classes.completedDareDetailsTextContainer
		: classes.detailsTextContainer
	const { writeText } = useClipboard()

	return (
		<Fragment>
			<DareDetailsTitleAndDescription />
			<div className={classNames('layout-column',
				projectDeliveries
					? classes.completedDareDetailsContainer
					: classes.detailsContainer)}
			>
				<div className={className}>
					<span className={classes.detailsText}>Game </span>
					<span className={classes.detailsTextValue}>
						{prop('name', head(games))}
					</span>
				</div>
				{timeLeft
					? (
						<CountdownTimer
							time={timeLeft}
							containerStyle={className}
							textStyle={classes.detailsText}
							valueStyle={classes.detailsTextValue}
							expiredStyle={classes.expired}
							isTwitchPanelDare={isTwitchPanelDare}
							infiniteStyle={classes.infiniteStyle}
						/>
					)
					: (
						<div className={className}>
							<span className={classes.detailsText}>Dare completed</span>
						</div>
					)
				}
				{brandProduct
					? (
						<Fragment>
							<div className={className}>
								<span className={classes.detailsText}>Reward </span>
								<span className={classes.detailsTextValue}>
									{getBountyName(brandProduct)} {
										prop('region', brandProduct) && (
											<Fragment>({camelCaseSpace(prop('region', brandProduct))})</Fragment>
										)
									}
								</span>
							</div>
							{isMobileRes && sponsor
							&& <Sponsoring sponsor={sponsor} classes={classes} isMobileRes={isMobileRes} campaignId={campaignId} />
							}
						</Fragment>
					)
					: (
						<Fragment>
							<div className={className}>
								<span className={classes.detailsText}>Pledgers </span>
								<span className={classes.detailsTextValue}>{pledgers}</span>
							</div>
							<div className={className}>
								<span className={classes.detailsText}>Total Pledged </span>
								<span className={classes.detailsTextValue}>
									${format2Decimals(pledgeAmount)}
									{orNull(goalAmount, <span> of ${format2Decimals(goalAmount)}</span>)}
								</span>
							</div>
						</Fragment>
					)
				}
				{creatorData && (
					<div className={classNames(className, classes.flexContainer)}>
						<span className={classes.detailsText}>Created by </span>
						<span className={classes.detailsTextValue}>
							<div
								className={classes.creatorDataWrapper}
								onClick={
									() => goToViewCreatorDataHandler(
										assigneeRouteSelector({
											...creatorData,
											mnemonicId: toLower(creatorData.displayName),
											platform: 'twitch',
										}),
									)
								}
							>
								<div className={classes.creatorImgWrapper}>
									<img
										src={addHttpsProtocol(creatorData.img)}
										alt="assignee"
									/>
								</div>
								{creatorData.displayName}
							</div>
						</span>
					</div>
				)}
				{ (isOneOfAssignees && landingShortUrl) && (
					<div className={className}>
						<span className={classes.detailsText}>Your Link to Share </span>
						<button
							type="button"
							onClick={() => writeText(addHttpsProtocol(landingShortUrl))}
							className={classNames(classes.detailsTextValue, classes.shortUrlProject)}
							style={{ cursor: 'pointer', outline: 'none', background: 'none', border: 'none' }}
							title="Copy"
						>
							{landingShortUrl}
							<FontAwesomeIcon icon={faCopy} style={{ marginLeft: 4 }} />
						</button>
					</div>
				)}
			</div>
		</Fragment>
	)
})
